export default "__VITE_ASSET__Bo6rmy$L__"